import { render, staticRenderFns } from "./joinTeam.vue?vue&type=template&id=62bd633c&scoped=true"
import script from "./joinTeam.vue?vue&type=script&lang=js"
export * from "./joinTeam.vue?vue&type=script&lang=js"
import style0 from "./joinTeam.vue?vue&type=style&index=0&id=62bd633c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd633c",
  null
  
)

export default component.exports